import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { useDevice } from "frontend/src/domain/devices";
import { useControlDevice } from "./model.new";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        buttonsWrapper: (_a = {
                display: "flex",
                flexDirection: "column",
                "& .MuiButtonBase-root": {
                    marginTop: theme.spacing(1),
                }
            },
            _a[theme.breakpoints.up("sm")] = {
                flexDirection: "row",
                marginTop: theme.spacing(1),
                "& .MuiButtonBase-root": {
                    marginTop: theme.spacing(0),
                    marginRight: theme.spacing(1),
                    "&:last-child": {
                        marginRight: 0,
                        marginLeft: "auto",
                    },
                },
            },
            _a),
        dislike: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.dark,
            "&:hover": {
                backgroundColor: theme.palette.error.main,
            },
        },
    });
});
export var ControlDevice = function (_a) {
    var _b, _c, _d, _e, _f;
    var id = _a.id;
    var classes = useStyles();
    var device = useDevice(id);
    var control = useControlDevice(id);
    return (React.createElement(Box, { component: Paper, p: 2, mt: 1 },
        React.createElement(Typography, { variant: "h5" }, "\u0412\u0435\u0449\u0430\u043D\u0438\u0435"),
        React.createElement(Box, { mt: 2 },
            React.createElement(Typography, { variant: "caption" }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
            React.createElement(Typography, { variant: "h6" }, device.isLoading ? (React.createElement(Skeleton, { width: 100 })) : ((_b = device.data) === null || _b === void 0 ? void 0 : _b.isOnline) ? ("Онлайн") : ("Оффлайн")),
            ((_c = device.data) === null || _c === void 0 ? void 0 : _c.nowPlaying) && (React.createElement(Box, { mt: 1 },
                React.createElement(Typography, { variant: "caption" }, "\u0421\u0435\u0439\u0447\u0430\u0441 \u0438\u0433\u0440\u0430\u0435\u0442"),
                React.createElement(Typography, { variant: "h6" }, (_d = device.data) === null || _d === void 0 ? void 0 :
                    _d.nowPlaying.title,
                    ((_e = device.data) === null || _e === void 0 ? void 0 : _e.nowPlaying.type) === "public" &&
                        "- " + ((_f = device.data) === null || _f === void 0 ? void 0 : _f.nowPlaying.artist)))),
            React.createElement(Box, { className: classes.buttonsWrapper, mt: 1 },
                React.createElement(ButtonLoader, { isLoading: control.play.isLoading, variant: "contained", color: "primary", size: "medium", onClick: control.play.run }, "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C"),
                React.createElement(ButtonLoader, { isLoading: control.stop.isLoading, variant: "outlined", color: "primary", size: "medium", onClick: control.stop.run }, "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C"),
                React.createElement(ButtonLoader, { isLoading: control.playNextTrack.isLoading, variant: "outlined", color: "primary", size: "medium", onClick: control.playNextTrack.run }, "\u0418\u0433\u0440\u0430\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0442\u0440\u0435\u043A"),
                React.createElement(ButtonLoader, { isLoading: control.refresh.isLoading, variant: "outlined", color: "primary", size: "medium", onClick: control.refresh.run }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441"),
                React.createElement(ButtonLoader, { isLoading: control.dislike.isLoading, variant: "contained", color: "secondary", size: "medium", className: classes.dislike, onClick: control.dislike.run }, "\u0423\u0431\u0440\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0442\u0440\u0435\u043A")))));
};
